import { FieldRegistration } from '../fieldRegistry';
import {
  extractTextValue,
  createTextUpdateHandler,
  resolveTextPlaceholder,
  createTextSerializer,
  createTextStoreSerializer,
  provideEmptyContext,
  validateTextField
} from '../fieldUtils';
import { renderDescriptionField } from './descriptionFieldRenderer';

export const descriptionFieldConfig: FieldRegistration = {
  renderer: renderDescriptionField,
  extractor: extractTextValue,
  updateHandler: createTextUpdateHandler(),
  placeholderResolver: resolveTextPlaceholder,
  apiSerializer: createTextSerializer(true),
  storeSerializer: createTextStoreSerializer(),
  contextProvider: provideEmptyContext,
  validator: validateTextField
};
